import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {DialogProps, IRegisterForm} from 'packages/common-types/base-types';
import RegisterForm from 'packages/auth/register/Form';
import useRegister from 'packages/hooks/use-register';
import {useEffect} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {CircularProgress} from '@material-ui/core';
import Swal from 'sweetalert2';

type Props = DialogProps & {};

const useStyles = makeStyles((theme) => ({
  dialogFooter: {
    padding: theme.spacing(2, 2),
  },
}));

export default function NewAccount(props: Props) {
  const {modalOpen, toggle} = props;
  const classes = useStyles();
  const methods = useForm<IRegisterForm>({
    mode: 'onBlur',
  });
  const {loading, onSubmit} = useRegister(false);

  useEffect(() => {
    if (methods?.formState?.isSubmitSuccessful) {
      methods.reset();
      toggle();
      Swal.fire({
        title: 'Hecho',
        text: 'Cuenta de usuario creada correctamente',
        icon: 'success',
      });
    }
  }, [methods, toggle]);

  return (
    <FormProvider {...methods}>
      <Dialog
        open={modalOpen}
        keepMounted={false}
        onClose={toggle}
        aria-labelledby="form-dialog-title"
      >
        {loading && <LinearProgress />}
        <DialogTitle id="create-tournament-dialog-title">
          Registrar un usuarios
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            Registre un usuario directamente a un torneo en caso tal de que no
            se encuentre pre-inscrito.
          </DialogContentText>
          <RegisterForm submitting={loading} onSubmit={onSubmit} />
        </DialogContent>
        <DialogActions className={classes.dialogFooter}>
          <Button onClick={toggle} color="primary">
            Cerrar
          </Button>
          <Button
            disabled={loading}
            form="create-account-form"
            type="submit"
            color="primary"
          >
            {loading ? (
              <CircularProgress color="secondary" size={24} />
            ) : (
              'Crear registro'
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </FormProvider>
  );
}
